
import axios from 'axios';

const EXTERNAL_API_BASE = 'https://api.countrystatecity.in/v1';
const API_KEY = '9b7b5e8f2f7a5c6878be007daa49bf004edbb187cfa72f507cbd8120b1ac7e0f';


const apiClient = axios.create({
    baseURL: EXTERNAL_API_BASE,
    headers: {
        'Content-Type': 'application/json',
        'X-CSCAPI-KEY': API_KEY,  
    },
});


export const fetchExternalCountries = async () => {
    try {
        const response = await apiClient.get('/countries');
        return response.data;
    } catch (error) {
        console.error('Error fetching countries:', error);
        throw error;
    }
};


export const fetchExternalStates = async (countryCode = 'IN') => {
    try {
        
        const response = await apiClient.get(`/countries/${countryCode}/states`);
        return response.data;
    } catch (error) {
        console.error('Error fetching states from external API:', error);
        throw error;
    }
};


export const fetchExternalCities = async (countryCode = 'IN', stateCode) => {
    try {
       
        const response = await apiClient.get(`/countries/${countryCode}/states/${stateCode}/cities`);
        return response.data;
    } catch (error) {
        console.error('Error fetching cities from external API:', error);
        throw error;
    }
};

